import { BilingualField } from '@src/permitField/AccountFields';
import * as JurisdictionIdNumberPermitFields from '@src/permitField/JurisdictionIdNumberFields';
import { BooleanField, Field } from '@src/permitField/PermitFields';
import { JurisdictionField } from '@src/permitTypesManager/permitTypeSections/PermitDefinitionFields';
import * as yup from 'yup';

export class AccountNumbersBilingualField extends BooleanField {
  public static fieldName: string = BilingualField.fieldName;
}

export class UsDotNumberField extends BooleanField {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.usDotNumber.fieldName;
}

export class FederalIDNumberField extends BooleanField {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.federalIdNumber.fieldName;
}

export class UsICCField extends BooleanField {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.usICC.fieldName;
}

export class UsIFTAField extends BooleanField {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.usIFTA.fieldName;
}

export class UsIRPNumberField extends BooleanField {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.usIRP.fieldName;
}

export class CaNSCField extends BooleanField {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.caNSC.fieldName;
}

export class AbMVIDNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.abMVIDNumberField.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'AB',
      then: (schema) => schema.required(),
    });
}

export class BcCustomerNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.bcCustomerNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'BC',
      then: (schema) => schema.required(),
    });
}

export class BcFINNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.bcFINNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'BC',
      then: (schema) => schema.required(),
    });
}

export class QcNIRNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.qcNIRNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'QC',
      then: (schema) => schema.required(),
    });
}

export class QcNEQNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.qcNEQNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'QC',
      then: (schema) => schema.required(),
    });
}

export class OnCVORNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.onCVORNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'ON',
      then: (schema) => schema.required(),
    });
}

export class OnPRIOAccountNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.onPRIOAccountNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'ON',
      then: (schema) => schema.required(),
    });
}

export class NLMasterNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.nlMasterNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'NL',
      then: (schema) => schema.required(),
    });
}

export class KentuckyNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.kentuckyNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'KY',
      then: (schema) => schema.required(),
    });
}

export class LaNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.laNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'LA',
      then: (schema) => schema.required(),
    });
}

export class MontanaNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.montanaNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'MT',
      then: (schema) => schema.required(),
    });
}

export class OregonNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.oregonNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'OR',
      then: (schema) => schema.required(),
    });
}

export class TennesseeNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.tennesseeNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'TN',
      then: (schema) => schema.required(),
    });
}

export class TexasNumberField extends Field {
  public static fieldName: string =
    JurisdictionIdNumberPermitFields.texasNumber.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'TX',
      then: (schema) => schema.required(),
    });
}
